import uuidv4 from 'uuid/v4';
import { mapState } from 'vuex';
import baseElement from '@/mixins/base-element/base-element-smart';
import { Rendering } from '@/data/data-models';

export default {
    mixins: [baseElement],

    props: {
        // rendering id from Sitecore layout
        renderingId: {
            type: String,
            default: 'c227160c-6e7e-4cad-a911-e26f463688e2',
        },

        renderingName: {
            type: String,
            default: '',
        },

        // whether the rendering is on final layout details or shared details (template)
        renderingField: {
            type: String,
            default: '',
        },

        // GUID of datasource item in Sitecore
        dataSourceId: {
            type: String,
            default: '',
        },

        // all child elements, 1 to 1 child items in Sitecore
        elements: {
            type: Array,
            default: () => ([]),
        },

        // set to true if the component is locked, i.e. can only be modified from within the Component Editor
        lockComponent: {
            type: Boolean,
            default: false,
        },

        linkedComponent: {
            type: String,
            default: '',
        },

        globalContent: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            atomicType: 'organism',
            elementsNew: null,
        };
    },

    computed: {
        ...mapState({
            deviceMode: state => state.page.deviceMode,
            holdEvents: state => state.page.holdEvents,
        }),

        updatedElementExcludeChildren() {
            const rendering = new Rendering({
                ...this.updatedBaseElement,
                renderingId: this.renderingId,
                renderingName: this.renderingName,
                dataSourceId: this.dataSourceId,
            });

            return rendering;
        },

        updatedElement() {
            const rendering = new Rendering({
                ...this.updatedBaseElement,
                renderingId: this.renderingId,
                renderingName: this.renderingName,
                dataSourceId: this.dataSourceId,
                elements: this.elementsNew,
            });

            return rendering;
        },
    },

    watch: {
        updatedElementExcludeChildren(val) {
            if (this.holdEvents) return;
            if (val.id === '') return; // don't update before data is populated
            this.$emit('element-updated', this.updatedElement);
        },
    },

    created() {
        this.templateType = 'Organism';
    },

    beforeMount() {
        this.setElements();
    },

    methods: {
        setElements() {
            this.elementsNew = [...this.elements];
        },

        element(pointer) {
            const element = this.elementsNew.find(e => pointer === e.pointer);
            if (element) return element;

            // set id and pointer then let the element set the other defaults
            const newElement = {
                id: uuidv4(),
                pointer,
            };

            this.elementsNew.push(newElement);
            return newElement;
        },

        elementUpdated(updatedElement) {
            if (this.holdEvents) return;
            const index = this.elementsNew.findIndex(element => element.id === updatedElement.id);
            if (index === -1) {
                console.error(
                    `Element ${ this.name }: could not match ID of updated element
                    ${ updatedElement.name } to existing element.`,
                );
                return;
            }

            this.$set(this.elementsNew, index, updatedElement);
        },
    },
};
